import { render, staticRenderFns } from "./PlusNChip.vue?vue&type=template&id=05b21ec4&scoped=true&lang=pug&"
import script from "./PlusNChip.vue?vue&type=script&lang=js&"
export * from "./PlusNChip.vue?vue&type=script&lang=js&"
import style0 from "./PlusNChip.vue?vue&type=style&index=0&id=05b21ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b21ec4",
  null
  
)

export default component.exports